"use client";

import { useEffect, useRef } from "react";
import { redirectSsoProfessionalToAuthorize } from "@Front/integrations/oauth-default/ssoOauthRedirect";
import {
	isSsoOAuthClientIdConfigured,
	resolveEffectiveSsoOAuthClientId,
} from "@Front/integrations/oauth-default/ssoOAuthBrowserUrls";
import { usePublicIntegrationFlags } from "@Front/Components/Layouts/Login/StepEmail/hooks/usePublicIntegrationFlags";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";

/**
 * Enso professional login: no local /login UI — immediate OAuth redirect to ssoPublicOriginByEnv.
 */
export function LoginSsoOAuthRedirectOnly(): React.JSX.Element {
	const { sso_oauth_client_id, ready } = usePublicIntegrationFlags();
	const startedRef = useRef(false);
	const redirectingText = useSiteTextContent("login.sso.redirecting");

	useEffect(() => {
		if (startedRef.current) {
			return;
		}
		const clientId = ready
			? resolveEffectiveSsoOAuthClientId(sso_oauth_client_id)
			: resolveEffectiveSsoOAuthClientId(null);
		if (!isSsoOAuthClientIdConfigured(clientId)) {
			return;
		}
		startedRef.current = true;
		void redirectSsoProfessionalToAuthorize(undefined, clientId);
	}, [ready, sso_oauth_client_id]);

	return (
		<p role="status" aria-live="polite">
			{redirectingText}
		</p>
	);
}
